/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ProgramConfigChangedField {
    START_TARGET = 'startTarget',
    INCREASE_AMOUNT_PER_LVL = 'increaseAmountPerLvl',
    INCREASE_LVL_AFTER_DAYS = 'increaseLvlAfterDays',
    MAX_TARGET = 'maxTarget',
    CURRENT_LVL = 'currentLvl',
    ENABLED = 'enabled',
    LOCKED_BY_DOCTOR = 'lockedByDoctor',
}
